import EmptyMessageWithLink from './EmptyMessageWithLink';

export default EmptyMessageWithLink;
